import React, { FC } from 'react';
import { Popover as AntdPopover } from 'antd';
import type { PopoverProps as AntdPopoverProps } from 'antd';
import Dropdown from './DropMenu';

export type PopoverPropsType = AntdPopoverProps;

const PopoverComponent: React.FC<PopoverPropsType> = (props) => {
    const {
        overlayClassName,
        classNames = {},
        children,
        ...rest
    } = props;

    return (
        <AntdPopover
            classNames={{
                root: overlayClassName,
                ...classNames
            }}
            {...rest}
        >
            <div style={{ position: 'relative' }}>
                {children}
            </div>
        </AntdPopover>
    );
};

type CompoundedComponent = FC<PopoverPropsType> & {
    DropMenu: typeof Dropdown;
};

const Popover = PopoverComponent as CompoundedComponent;
Popover.DropMenu = Dropdown;

export default Popover;
